import React, {useState, useEffect} from "react";
import ItemLanguage from "../ItemLanguage/ItemLanguage";
import classes from './ModalSetLanguage.module.scss'
import { useTranslation } from "react-i18next";

const ModalSetLanguage = (props: any) => {
    const {t, i18n} = useTranslation()
    const [textLanguage, setTextLanguage] = useState('EN')

    // useEffect(() => {
    //     i18n.changeLanguage('en')
    // }, [])

    const changeLanguage = (language: any) => {
        i18n.changeLanguage(language)
        setTextLanguage(language)
        props.hideModal()
    }
    return(
        <div className={props.modalActive ? classes.modal : classes.close}>
            <ItemLanguage 
                src={require('../../img/unitedStates.png')} 
                text={'English'}
                alt = {'English'} 
                value={'EN'} 
                textLanguage={textLanguage} 
                setTextLanguage={setTextLanguage} 
                onChangeLanguage={changeLanguage}
                id={1}
                currentLanguage={props.currentLanguage}
                setCurrentLanguage={(lng:any) => props.setCurrentLanguage(lng)}/>

            <ItemLanguage 
                src={require('../../img/poland.png')}  
                text={'Polish'} 
                alt = {'Polish'} 
                value={'PL'} 
                textLanguage={textLanguage} 
                setTextLanguage={setTextLanguage} 
                onChangeLanguage={changeLanguage}
                id={2}
                currentLanguage={props.currentLanguage}
                setCurrentLanguage={(lng:any) => props.setCurrentLanguage(lng)}/>

            <ItemLanguage 
                src={require('../../img/russia.png')} 
                text={'Russian'} 
                alt = {'Russian'} 
                value={'RU'} 
                textLanguage={textLanguage} 
                setTextLanguage={setTextLanguage} 
                onChangeLanguage={changeLanguage}
                id={3}
                currentLanguage={props.currentLanguage}
                setCurrentLanguage={(lng:any) => props.setCurrentLanguage(lng)}/>

        </div> 
    )
}

export default ModalSetLanguage